<template lang='pug'>
	.contenido-2-columnas-B
		.contenedor-contenido-2-columnas
			.contenido
				.modulo.m1
					img(src='~Img/full01.png')
					h1
						| Delivering value to Architects, Contractors, and Homeowners
					br
					p.caja-texto1
						| In addition to our online offerings, EasyTitle24.com offers traditional full service Title 24 Reports and Title 24 Energy Consulting services by experienced Certified Energy Analysts, that will:
						br
						br
						ul
							li
								| Provide you with the most cost-effective manner to minimize overall design and construction costs while meeting Title24 energy compliance.
							li
								| Provide you with maximum design flexibility
							li
								| Help your construction process go as smoothly as possible.
						| Residential Title 24 is done holistically, not broken into parts like nonresidential projects.
						br
						br
						span
							| If your project is residential, you could be interested in &nbsp
							router-link(to='/do-it-yourself')
								span
									| Do It Yourself
						br
						router-link(to='/compliance-wizard')
								span: | Title 24 Analysis Fees according to scope and method
				.modulo.m2
					img(src='~Img/full02.png')
					h1
						| How do we do it?
					br
					p.caja-texto1
						| Non-residential Title 24 energy compliance is typically divided between four distinct areas:
						br
						br
						ul
							li
								| The Envelope, that is, the exterior surfaces of the building/space.
							li
								| Lighting
							li
								| Mechanical Systems
							li
								| Outdoor Lighting
						| We provide our services under the assumption that you want to minimize overall design and construction costs.
						br
						br
						| To do this, it is strongly advisable to combine Envelope, Lighting, and Mechanical (or as many parts as possible) together into a <span> performance </span> analysis, so that energy savings in one area can be traded against overages in another.
						br
						| Not many companies can provide this type of service at out level of expertise. Of course, we can handle any single discipline on its own, and the <span> performance </span> approach can still provide benefits, especially for Envelope Title 24.
						br
</template>
<script>
export default {
	name: 'content-2-columns'
}
</script>



// WEBPACK FOOTER //
// src/components/full/content2Columns.vue